import React from 'react';

import Editors from './editor.js';
const Gym = () => {
	return (
		<>
			<Editors id={"Gym"}/>
		</>
	);
};
export default Gym;
